import React from "react";
import { graphql, useStaticQuery } from "gatsby";

const Logo = () => {
  const imageData = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo.jpg" }) {
        publicURL
      }
    }
  `);
  return (
    <img
      src={imageData.logo.publicURL}
      width="100%"
      alt="Logo"
      className="align-middle"
    ></img>
  );
};

export default Logo;
